/* ==========================================================================
   claude 一扫双果 scan-pair — 交互
   职责只有一件：全景 iframe 的注入、加载反馈与销毁。

   状态（写在全景容器的 data-sr-state 上，CSS 据此显隐）：
     idle     封面 + 打开按钮。点击前零请求
     loading  点击后立刻进入：封面压暗 + 转圈；iframe 透明加载
     slow     超过 data-sr-slow 秒仍未 load：慢速文案 + 重试
     live     iframe 触发 load：显示全景，右上角重新加载 + 关闭

   - 「打开全景」与站位点都是 <button>，只在原页面注入，永不跳转
   - 关闭 / Esc 立即销毁；离开视口保留 data-sr-keep 秒后才销毁
   - 跨域 iframe 的报错页（连接已重置等）同样会触发 load，代码无法区分，
     所以 live 状态下重新加载按钮常驻
   ========================================================================== */

(function () {
  'use strict';

  var ATTR = 'srInit';

  function initPair(root) {
    if (!root || root.dataset[ATTR] === 'true') return;
    root.dataset[ATTR] = 'true';

    var holder = root.querySelector('[data-sr-pano]');
    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var slowAfter = parseInt(root.getAttribute('data-sr-slow'), 10);
    if (isNaN(slowAfter)) slowAfter = 8;
    var keepFor = parseInt(root.getAttribute('data-sr-keep'), 10);
    if (isNaN(keepFor)) keepFor = 30;

    var textEl = holder ? holder.querySelector('[data-sr-loadtext]') : null;
    var slowTimer = null;
    var dropTimer = null;

    function state() { return holder ? holder.getAttribute('data-sr-state') : 'idle'; }

    function setState(s) {
      if (!holder) return;
      holder.setAttribute('data-sr-state', s);
      if (textEl) {
        var key = s === 'slow' ? 'data-sr-text-slow' : 'data-sr-text-loading';
        var txt = textEl.getAttribute(key);
        if (txt) textEl.textContent = txt;
      }
    }

    function focusEl(el) {
      if (!el) return;
      try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
    }

    function clearTimer(t) { if (t) window.clearTimeout(t); return null; }

    function destroy(restoreFocus) {
      if (!holder) return;
      slowTimer = clearTimer(slowTimer);
      dropTimer = clearTimer(dropTimer);
      var f = holder.querySelector('iframe');
      if (f) f.parentNode.removeChild(f);
      setState('idle');
      if (restoreFocus) focusEl(holder.querySelector('[data-sr-pano-trigger]'));
    }

    function open(trigger) {
      if (!holder || holder.querySelector('iframe')) return;
      var url = holder.getAttribute('data-sr-pano');
      if (!url) return;

      /* 先切状态再建 iframe：加载层在同一帧出现，点击立刻有反馈 */
      setState('loading');

      var f = document.createElement('iframe');
      f.title = holder.getAttribute('data-sr-pano-title') || 'Panorama';
      f.allow = 'fullscreen; accelerometer; gyroscope; xr-spatial-tracking';
      f.setAttribute('allowfullscreen', '');
      f.addEventListener('load', function () {
        if (!holder.contains(f)) return;          /* 已被关闭或重试替换 */
        slowTimer = clearTimer(slowTimer);
        setState('live');
      });
      f.src = url;
      holder.appendChild(f);

      slowTimer = window.setTimeout(function () {
        if (state() === 'loading') setState('slow');
      }, slowAfter * 1000);

      /* 从点云上的站位点触发时全景在另一格：移动端堆叠时把它滚进视口 */
      if (trigger && !holder.contains(trigger) && mq.matches && holder.scrollIntoView) {
        try { holder.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } catch (err) {}
      }

      focusEl(holder.querySelector('[data-sr-pano-close]'));
    }

    function retry() {
      destroy(false);
      open(null);
    }

    var onClick = function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('[data-sr-pano-trigger]');
      if (t && root.contains(t)) { e.preventDefault(); open(t); return; }
      if (e.target.closest('[data-sr-pano-retry]')) { e.preventDefault(); retry(); return; }
      if (e.target.closest('[data-sr-pano-close]')) { e.preventDefault(); destroy(true); }
    };
    root.addEventListener('click', onClick);

    /* 焦点在 iframe 里时按键不会冒泡出来；关闭按钮始终可见，是主要退出方式 */
    var onKey = function (e) {
      if (e.key === 'Escape' && state() !== 'idle') destroy(true);
    };
    root.addEventListener('keydown', onKey);

    /* 离开视口不立即销毁：滚走再滚回来不用重新加载 */
    var io = null;
    if (holder && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) {
            dropTimer = clearTimer(dropTimer);
          } else if (state() !== 'idle') {
            if (keepFor <= 0) destroy(false);
            else if (!dropTimer) dropTimer = window.setTimeout(function () { dropTimer = null; destroy(false); }, keepFor * 1000);
          }
        }
      }, { threshold: 0 });
      io.observe(holder);
    }

    root._srTeardown = function () {
      destroy(false);
      if (io) io.disconnect();
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKey);
      delete root.dataset[ATTR];
      delete root._srTeardown;
    };
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-sr-root]');
    for (var i = 0; i < roots.length; i++) initPair(roots[i]);
  }

  function rootOf(t) { return t && t.querySelector ? t.querySelector('[data-sr-root]') : null; }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = rootOf(e.target); if (r) initPair(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = rootOf(e.target); if (r && r._srTeardown) r._srTeardown();
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    var r = rootOf(e.target); if (r) { if (r._srTeardown) r._srTeardown(); initPair(r); }
  });
})();